module.exports = __webpack_public_path__ + "static/media/AddaptedApp.1a64ab6f.png";